export const easings = {
  linear: (t: number) => t,
  easeOutCubic: (t: number) => 1 - Math.pow(1 - t, 3),
  easeOutQuart: (t: number) => 1 - Math.pow(1 - t, 4),
  easeOutExpo: (t: number) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
  easeInOutCubic: (t: number) =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2,
  easeInOutExpo: (t: number) =>
    t === 0
      ? 0
      : t === 1
        ? 1
        : t < 0.5
          ? Math.pow(2, 20 * t - 10) / 2
          : (2 - Math.pow(2, -20 * t + 10)) / 2,
} as const;

export type EasingFn = (t: number) => number;

export function smoothScrollTo(
  el: HTMLElement,
  target: number,
  duration: number,
  easing: EasingFn = easings.easeInOutExpo,
  onDone?: () => void,
): () => void {
  const start = el.scrollTop;
  const change = target - start;
  if (Math.abs(change) < 1) {
    onDone?.();
    return () => {};
  }
  const prevSnap = el.style.scrollSnapType;
  el.style.scrollSnapType = "none";
  const startTime = performance.now();
  let cancelled = false;
  const restore = () => {
    el.style.scrollSnapType = prevSnap;
  };
  const step = (now: number) => {
    if (cancelled) return;
    const elapsed = now - startTime;
    const progress = Math.min(elapsed / duration, 1);
    el.scrollTop = start + change * easing(progress);
    if (progress < 1) {
      requestAnimationFrame(step);
    } else {
      restore();
      onDone?.();
    }
  };
  requestAnimationFrame(step);
  return () => {
    cancelled = true;
    restore();
  };
}
